import { keyframes } from 'tss-react';

const loadingKeyframes = keyframes({
    '0%': {
        opacity: 0.2,
    },
    '50%': {
        opacity: 0.5,
    },
    '100%': {
        opacity: 0.2,
    },
});

export default (theme, { sectioned }, classes) => ({
    title: {
        // `sectioned` opt-in: white header separated from the grey body by a divider
        // (the standard "Add a manual task" Figma treatment).
        borderBottom: sectioned ? `1px solid ${theme.palette.divider}` : undefined,
    },
    content: {
        ...theme.typography.body1,
        backgroundColor: sectioned ? theme.palette.grey[50] : undefined,
        margin: 0,
        paddingTop: 0,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingBottom: sectioned ? theme.spacing(3) : theme.spacing(1),
        [`.${classes.title} + &`]: {
            // This is a hack to fix the overflow hidden between the dialog title and the dialog content.
            // When `sectioned`, the sections are separated by dividers, so the negative margin (which
            // would pull the grey body over the title divider) is dropped. Use padding (not margin) so
            // the grey body sits flush against the header divider instead of leaving a white gap below it.
            marginTop: sectioned ? 0 : theme.spacing(-1),
            paddingTop: sectioned ? theme.spacing(3) : theme.spacing(1),
        },
        '& .MuiInputBase-root': {
            backgroundColor: sectioned ? theme.palette.background.paper : undefined,
        },
    },
    actions: {
        display: 'flex',
        // When `sectioned`, keep the white footer flush against the body and separate it with a divider.
        marginTop: sectioned ? 0 : theme.spacing(2),
        marginBottom: sectioned ? 0 : theme.spacing(2),
        paddingTop: sectioned ? theme.spacing(2) : 0,
        paddingBottom: sectioned ? theme.spacing(2) : 0,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        borderTop: sectioned ? `1px solid ${theme.palette.divider}` : undefined,
    },
    defaultActions: {
        display: 'flex',
        flex: theme.spacing(1),
        gap: theme.spacing(1),
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
    },
    body: {
        margin: theme.spacing(0, 0, 2),
        padding: theme.spacing(0, 3),
        whiteSpace: 'pre-line',
    },
    disclaimer: {
        color: theme.palette.text.hint,
    },
    cancelButton: {
        marginRight: theme.spacing(1),
        borderColor: theme.palette.grey[400],
        color: theme.palette.grey[600],
        '&:hover': {
            borderColor: theme.palette.grey[600],
            color: theme.palette.grey[700],
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    loadingOverlay: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noScroll: {
        pointerEvents: 'none',
        animation: `${loadingKeyframes} 2.75s ease-in-out infinite`,
    },
    delegateScroll: {
        display: 'flex',
        flexDirection: 'column',
    },
});
